import { buildBinderListings } from '@monofe/di';
import cacheBind from './impl/cache.bind';
import callbackBind from './impl/callback.bind';
import channelBind from './impl/channel.bind';
import fetchHelperBind from './impl/fetch.bind';
import loggerBind from './impl/log.bind';
import regexJSONBind from './impl/regex.bind';
import requestJSONBind from './impl/requestJSON.bind';
import responseJSONBind from './impl/responseJSON.bind';
import kvStorageBind from './impl/settingsStorage.bind';
import zipBind from './impl/zip.bind';

export default buildBinderListings([
    cacheBind,
    callbackBind,
    channelBind,
    fetchHelperBind,
    loggerBind,
    regexJSONBind,
    requestJSONBind,
    responseJSONBind,
    kvStorageBind,
    zipBind,
]);
